import { Flex, Input, Typography } from "antd";
import { useTranslate } from "@refinedev/core";
import { IncreaseDecreaseNumberInput } from "../../../controls/IncreaseDecreaseNumberInput";

export const TableThemePlaceholdersFeature = ({
  count,
  onCountChange,
  baseText,
  onBaseTextChange,
}: {
  count: number;
  onCountChange: (count: number) => void;
  baseText: string;
  onBaseTextChange: (baseText: string) => void;
}) => {
  const t = useTranslate();

  return (
    <Flex vertical gap={12}>
      <Flex vertical gap={4}>
        <Typography.Text style={{ fontSize: 12 }}>
          {t("components.templates.settings.tableTab.bulletPointCount")}
        </Typography.Text>
        <IncreaseDecreaseNumberInput
          value={count}
          onChange={(value) => {
            if (typeof value === "number") {
              onCountChange(value);
            }
          }}
        />
      </Flex>
      <Flex vertical gap={4}>
        <Typography.Text style={{ fontSize: 12 }}>
          {t("components.templates.settings.tableTab.bulletPointText")}
        </Typography.Text>
        <Input
          value={baseText}
          onChange={(e) => onBaseTextChange(e.target.value)}
        />
      </Flex>
    </Flex>
  );
};
